import React, { useState } from "react";
import "./NavMenu.css";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Link } from "react-router-dom";


export default function NavMenu({ menu = [], categories = [] }) {
    /* ---------------- DESKTOP STATES ---------------- */
    const [hoverBrand, setHoverBrand] = useState(null); // brand slug
    const [hoverBrandCategory, setHoverBrandCategory] = useState(null); // category under brand
    const [hoverCategory, setHoverCategory] = useState(null); // main categories tab

    /* ---------------- MOBILE STATES ---------------- */
    const [mobileOpen, setMobileOpen] = useState(false);
    const [mobileOpenBrand, setMobileOpenBrand] = useState(null);
    const [mobileOpenBrandCategory, setMobileOpenBrandCategory] = useState(null);
    const [mobileOpenMainCategory, setMobileOpenMainCategory] = useState(null);

    /* Reset for desktop hover leaving */
    const resetDesktop = () => {
        setHoverBrand(null);
        setHoverBrandCategory(null);
        setHoverCategory(null);
    };

    const handleLinkClick = () => {
        setMobileOpen(false);
        setMobileOpenBrand(null);
        setMobileOpenBrandCategory(null);
        setMobileOpenMainCategory(null);
    };

    return (
        <>
            {/* ---------------- DESKTOP MENU ---------------- */}
            <nav className="nav desktop-nav">
                <ul className="nav__list">
                    {/* BRANDS */}
                    <li className="nav__item nav__item--parent" onMouseLeave={resetDesktop}>
                        <span className="nav__link">
                            Brands <ExpandMoreIcon className="icon" />
                        </span>

                        <ul className="dropdown dropdown--brand">
                            {menu.map((brand) => (
                                <li key={brand.slug} className="dropdown__item dropdown__item--brand">
                                    <Link to={`/brand/${brand.slug}`} className="dropdown__link">
                                        {brand.name}
                                        {brand.categories?.length > 0 && <ChevronRightIcon className="rotate-icon-right" />}
                                    </Link>

                                    {brand.categories && (
                                        <ul className="dropdown dropdown--category">
                                            {brand.categories.map((cat) => (
                                                <li key={cat.slug} className="dropdown__item dropdown__item--category">
                                                    <Link to={`/brand/${brand.slug}/${cat.slug}`} className="dropdown__link">
                                                        {cat.name}
                                                        {cat.subcategories?.length > 0 && <ChevronRightIcon className="rotate-icon-right" />}
                                                    </Link>

                                                    {cat.subcategories && (
                                                        <ul className="dropdown dropdown--subcategory">
                                                            {cat.subcategories.map((sub) => (
                                                                <li key={sub.slug} className="dropdown__item dropdown__item--subcategory">
                                                                    <Link
                                                                        to={`/brand/${brand.slug}/${cat.slug}/${sub.slug}`}
                                                                        className="dropdown__link"
                                                                    >
                                                                        {sub.name}
                                                                    </Link>
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    )}
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </li>
                            ))}
                        </ul>

                    </li>

                    {/* CATEGORIES */}
                    <li className="nav__item nav__item--parent" onMouseLeave={resetDesktop}>
                        <span className="nav__link">
                            Categories <ExpandMoreIcon className="icon" />
                        </span>

                        <ul className="dropdown dropdown--brand">
                            {categories.map((cat) => (
                                <li key={cat.slug} className="dropdown__item dropdown__item--category">
                                    <Link to={`/${cat.slug}`} className="dropdown__link">
                                        {cat.name}
                                        {cat.subcategories?.length > 0 && <ChevronRightIcon className="rotate-icon-right" />}
                                    </Link>

                                    {cat.subcategories && (
                                        <ul className="dropdown dropdown--subcategory">
                                            {cat.subcategories.map((sub) => (
                                                <li key={sub.slug}>
                                                    <Link to={`/${cat.slug}/${sub.slug}`} className="dropdown__link">
                                                        {sub.name}
                                                    </Link>
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </li>
                            ))}
                        </ul>

                    </li>
                </ul>
            </nav>

            {/* ---------------- MOBILE MENU ---------------- */}
            <div className="mobile-nav">
                {/* Hamburger Only */}
                <button
                    className="btn btn-link header-icon-btn"
                    onClick={(e) => { setMobileOpen(!mobileOpen); e.stopPropagation(); }}
                >
                    <span className="navbar-toggler-icon"></span>
                </button>

                {/* Overlay */}
                {mobileOpen && <div className="mobile-overlay" onClick={() => setMobileOpen(false)}></div>}

                {/* Sidebar */}
                <div className={`mobile-menu ${mobileOpen ? "open" : ""}`}>
                    {/* BRANDS */}
                    <div>
                        <div
                            className="mobile-item"
                            onClick={() => setMobileOpenBrand(mobileOpenBrand === "brands" ? null : "brands")}
                        >
                            <span>Brands</span>
                            <span className={mobileOpenBrand === "brands" ? "rotate" : ""}>›</span>
                        </div>

                        {mobileOpenBrand === "brands" && (
                            <div className="mobile-sub">
                                {menu.map((brand) => (
                                    <div key={brand.slug}>
                                        <div
                                            className="mobile-item"
                                            onClick={() =>
                                                setMobileOpenBrandCategory(
                                                    mobileOpenBrandCategory === brand.slug ? null : brand.slug
                                                )
                                            }
                                        >
                                            <span>{brand.name}</span>
                                            <span className={mobileOpenBrandCategory === brand.slug ? "rotate" : ""}>›</span>
                                        </div>

                                        {mobileOpenBrandCategory === brand.slug && (
                                            <div className="mobile-sub-2">
                                                {brand.categories?.map((cat) => (
                                                    <div key={cat.slug}>
                                                        <Link
                                                            to={`/brand/${brand.slug}/${cat.slug}`}
                                                            className="child2"
                                                            onClick={handleLinkClick}
                                                        >
                                                            {cat.name}
                                                        </Link>
                                                        <div className="mobile-sub-3">
                                                            {cat.subcategories?.map((sub) => (
                                                                <Link
                                                                    key={sub.slug}
                                                                    to={`/brand/${brand.slug}/${cat.slug}/${sub.slug}`}
                                                                    className="child2"
                                                                    onClick={handleLinkClick}
                                                                >
                                                                    {sub.name}
                                                                </Link>
                                                            ))}
                                                        </div>
                                                    </div>
                                                ))}

                                            </div>
                                        )}
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>

                    {/* MAIN CATEGORIES */}
                    <div>
                        <div
                            className="mobile-item"
                            onClick={() => setMobileOpenMainCategory(mobileOpenMainCategory === "categories" ? null : "categories")}
                        >
                            <span>Categories</span>
                            <span className={mobileOpenMainCategory === "categories" ? "rotate" : ""}>›</span>
                        </div>

                        {mobileOpenMainCategory === "categories" && (
                            <div className="mobile-sub">
                                {categories.map((cat) => (
                                    <div key={cat.slug}>
                                        <Link to={`/${cat.slug}`} className="child2" onClick={handleLinkClick}>
                                            {cat.name}
                                        </Link>
                                        <div className="mobile-sub-2">
                                            {cat.subcategories?.map((sub) => (
                                                <Link key={sub.slug} to={`/${cat.slug}/${sub.slug}`} className="child2" onClick={handleLinkClick}>
                                                    {sub.name}
                                                </Link>
                                            ))}
                                        </div>
                                    </div>
                                ))}

                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
}
